import React, { Component } from "react";
import { Scatter } from "@ant-design/plots";

export default class ScatterChartResolution extends Component {
  config = {
    appendPadding: 10,
    data: this.props.data.filter(function (image) {
      return image.file_type != "svg";
    }),
    xField: "width",
    yField: "height",
    shape: "circle",
    colorField: "resolution",
    legend: {
      position: "top",
    },
    size: 2,
    color: ({ resolution }) => {
      switch (resolution) {
        case "Low-res":
          return "#FF7875";

        case "Mid-res":
          return "#69C0FF";

        case "High-res":
          return "#40A9FF";

        default:
          return "#40A9FF";
      }
    },
    xAxis: {
      grid: {
        line: {
          style: {
            stroke: "#eee",
          },
        },
      },
      line: {
        style: {
          stroke: "#aaa",
        },
      },
    },
  };

  render() {
    return <Scatter {...this.config} />;
  }
}
